import {inject, Injectable} from '@angular/core';
import {MatSnackBar}        from '@angular/material/snack-bar';
import {lastValueFrom}      from 'rxjs';
import {UiSnackComponent}   from '../comps/ui/ui-snack/ui-snack.component';

@Injectable({
				providedIn: 'root'
			})
export class UiNotificationsService {
	snackBar = inject(MatSnackBar)

	async showNotification(message: string, duration: number = 3000) {
		const snack = this.snackBar.openFromComponent(
			UiSnackComponent,
			{
				duration,
				data      : {
					message
				},
				panelClass: 'custom-snack-container'
			}
		);

		return lastValueFrom(snack.afterDismissed());
	}
}